import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';

import { UserExperienceService } from '@services/user-experience.service';
import { SummitDisposing } from '@summit/models';
import { LayoutService } from '@summit/ui';

@Injectable()
export class DashboardGuard extends SummitDisposing implements CanActivate {
  constructor(private router: Router, private uxService: UserExperienceService, public layoutService: LayoutService) {
    super();
  }

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    if (this.uxService.getUserExperience().isLoggedIn()) {
      // logged in so return true
      if (!this.router.url.startsWith('/dashboard')) {
        //console.log('Dashboard Guard - Navigating to Dashboard');
        this.router.navigate(['/dashboard']);
      }
      return true;
    }
    //this.uxService.toggleSideBar();
    //this.layoutService.toggleSideBar();
    // not logged in so redirect to login page
    return true;
  }
}
